import React from 'react';
import styled from 'styled-components';

const TitleDiv = styled.div`
  grid-area: ${(p) => p.grid};
`;

const Header = styled.h2`
  text-align: center;
  font-size: 1.5rem;
  font-weight: 500;
`;

function Title({ grid, children }) {
  return (
    <TitleDiv grid={grid}>
      <Header>{children}</Header>
    </TitleDiv>
  );
}

export default Title;
